// extracted by mini-css-extract-plugin
export default {"root":"gnVN_jLoxB2UmZpY45gt"};